module.exports = "/images/bg-footer.png?c8e6335118513f2313162a77a9506d63";